import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "Redux/Actions/actionTypes";
import GetPaysafeDetails from "../../Communication/ApiClasses/GetPaysafeDetails";

// worker
function* handleGetPaysafeDetails(action) {
  yield put(doLoadingStart(`${actionTypes.GET_PAYSAFE_DETAILS}_SAGA`));
  const getPaysafeDetailsApi = new GetPaysafeDetails(action.applicationId);
  try {
    const result = yield call(getPaysafeDetailsApi.getData);
    yield call(action.callback, result);
  } catch (error) {
    yield call(action.callback, error.response);
  } finally {
    yield put(doLoadingFinish(`${actionTypes.GET_PAYSAFE_DETAILS}_SAGA`));
  }
}

// watcher
export default function* getPaysafeDetailsWatcherSaga() {
  yield takeLatest(actionTypes.GET_PAYSAFE_DETAILS, handleGetPaysafeDetails);
}
